import TransferSelector from './components/TransferSelector/TransferSelector.css';
import TransferSelectorModal from './components/TransferSelectorModal/TransferSelectorModal.css';
import TransferService from './components/TransferService/TransferService.css';

export default {
	TransferService,
	TransferSelector,
	TransferSelectorModal
};
